import { METRICS_REVENUE_PATH } from 'cpmCarparks/navigation';

module.exports = {
  path: METRICS_REVENUE_PATH,
  getComponent(nextState, cb) {
    require.ensure([], (require) => {
      cb(null, require('./components/CarparkMetricsRevenue'));
    });
  },
};



// WEBPACK FOOTER //
// ./routes/cpm/routes/carparks/routes/show/routes/metricsRevenue/index.js